import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { CHART_COLORS } from '../../lib/chart-theme';

interface PieSlice {
    name: string;
    value: number;
    sort_order?: number;
}

interface ReportPieChartProps {
    title: string;
    data: PieSlice[];
    loading?: boolean;
    height?: number;
    valueFormatter?: (value: number) => string;
    onSliceClick?: (name: string) => void;
}

export function ReportPieChart({ title, data, loading, height = 350, valueFormatter, onSliceClick }: ReportPieChartProps) {
    const sorted = [...data].sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));

    const option: EChartsOption = {
        tooltip: {
            trigger: 'item',
            formatter: (params: any) => {
                const val = valueFormatter ? valueFormatter(params.value) : params.value;
                return `${params.name}: ${val} (${params.percent}%)`;
            },
        },
        legend: { orient: 'horizontal', bottom: 0, type: 'scroll' },
        color: CHART_COLORS,
        series: [{
            type: 'pie',
            radius: ['35%', '65%'],
            center: ['50%', '50%'],
            data: sorted.map((s) => ({ name: s.name, value: s.value })),
            label: { formatter: '{b}: {d}%', fontSize: 11 },
            emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,0.2)' } },
        }],
    };

    const onEvents = onSliceClick
        ? { click: (params: any) => onSliceClick(params.name) }
        : undefined;

    return (
        <div>
            <h4 className="text-sm font-medium text-gray-700 text-center mb-1">{title}</h4>
            <ReactECharts
                option={option}
                style={{ height: `${height}px` }}
                showLoading={loading}
                onEvents={onEvents}
            />
        </div>
    );
}
